import { SearchResult } from "./components";
import { useEffect, useState } from "react";
import SearchContext from "context/SearchContext";
import { SEARCH_PARAMS } from "constants/routes";
import {
  objectToQueryString,
  parseSearchParams,
  useQueryParam,
} from "helpers/search";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { LISTING_CARD_LIMIT } from "constants/layout";
import { Helmet } from "react-helmet";
import { SearchParamsType } from "types/params";
import { LISTING_OUTLET_PARAMS } from "constants/params";
import { BuyerBanners } from "Pages/home/components";

interface ParamTypes {
  categoryId: string;
  countryId?: string;
}

const Category = () => {
  const location = useLocation();
  const history = useHistory();
  const { pathname, search } = location;
  const { categoryId, countryId } = useParams<ParamTypes>();
  const searchKeyword = useQueryParam(SEARCH_PARAMS.keyword);
  const pageKeyword = useQueryParam(SEARCH_PARAMS.page);
  const categoryClass = pathname.split("/")[1];
  const isVerifiedParam = useQueryParam(SEARCH_PARAMS.is_verified);
  const countriesParam = useQueryParam(SEARCH_PARAMS.countries);
  const premiumParam = useQueryParam(SEARCH_PARAMS.premium);
  const sortParam = useQueryParam(SEARCH_PARAMS.sort);

  const [categoryLabel, setCategoryLabel] = useState();
  const [params, setParams] = useState<SearchParamsType>({
    limit: LISTING_CARD_LIMIT.category,
    keyword: searchKeyword,
    category_id: categoryId,
    category_class: categoryClass,
    page: Number(pageKeyword || "1"),
    country: countryId,
    filters: {
      is_verified: isVerifiedParam ? Number(isVerifiedParam) : undefined,
      countries: countriesParam ? countriesParam.split(",") : undefined,
      premium: premiumParam ? premiumParam.split(",") : undefined,
    },
    sort: sortParam || "hot",
  });

  const onUpdateParams = (updateData: any, forceEdited: boolean = false) => {
    const nextData = { ...params, ...updateData };
    const { page = 1, keyword } = nextData;
    history.replace({
      search: objectToQueryString({
        page,
        keyword,
      }),
    });
  };

  useEffect(() => {
    const queryData = parseSearchParams(search, LISTING_OUTLET_PARAMS);
    const { page, ...rest } = queryData;
    setParams({
      ...params,
      ...rest,
      page: Number(page) || 1,
      category_id: categoryId,
    });
  }, [search, categoryId]);

  return (
    <SearchContext.Provider
      value={{
        params,
        onUpdateParams,
        setCategoryLabel,
        categoryLabel,
      }}
    >
      <Helmet>
        {(searchKeyword || pageKeyword) && (
          <meta name="robots" content="noindex, follow" />
        )}
      </Helmet>
      {/* <BuyerBanners positionBanner={isLoggedIn ?"header-login": "header-not-login"} isNotRandom={false}/> */}
      <BuyerBanners positionBanner="header-not-login" isNotRandom={false}/>
      <SearchResult />
      <BuyerBanners positionBanner='footer' isNotRandom={false}/>
    </SearchContext.Provider>
  );
};

export default Category;
